module.exports = __webpack_public_path__ + "img/Z.848429c3.jpg";